import { UpdatePermissionsResponse, UsersResponse } from '../types/user.types';
import { ApiService } from './api.service';

interface User {
  _id: string;
  email: string;
  name: string;
  role: string;
  userPermissions: Array<{ permission: string }>;
}

interface CreateUserData {
  name: string;
  email: string;
  password: string;
  role: string;
}

interface CreateUserResponse {
  success: boolean;
  data: User;
  message?: string;
}

export class UserService {
  static async getUsers(): Promise<UsersResponse> {
    return ApiService.get<UsersResponse>('/users');
  }

  static async updatePermissions(
    userId: string, 
    permissions: string[]
  ): Promise<UpdatePermissionsResponse> {
    return ApiService.patch<UpdatePermissionsResponse>(
      `/users/${userId}/permissions`, 
      { permissions }
    );
  }

  static async createUser(userData: CreateUserData): Promise<CreateUserResponse> {
    return ApiService.post<CreateUserResponse>('/users', userData);
  }
} 